<template>
  <el-dialog
          :title="'设置工资'"
          :close-on-click-modal="false"
          :visible.sync="visible"
          style="text-align: left">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
             label-width="150px">
      <el-form-item label="工资模板" prop="salaryTemplateId">
        <el-select clearable  filterable    v-model="dataForm.salaryTemplateId" placeholder="输入姓名" >
          <el-option
                  v-for="item in salaryTemplates"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
            <span style="float: left">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.isHz===0?'合同工':item.isHz===1?'划转工':'校园' }}</span>
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {

    data () {
      const validateNumber = (rule, value, callback) => {
        var patrn = /^\d+(\.\d+)?$/;
        if (!patrn.exec(value)) {
          callback(new Error('请填写数字'))
        } else {
          callback()
        }
      }
      return {
        dataForm: {
          userid: '',
          salaryTemplateId: ''
        },
        salaryTemplates:[],
        visible:false,
        dataRule: {
          salaryTemplateId: [
            {required: true, message: '请选择工资模板', trigger: 'blur'},

          ],
        }
      }
    },
    methods: {
      init (id) {
        if(!id) return
        this.visible = true
        this.dataForm.userid = id.userid

        this.getSalaryTemplates()
        this.$nextTick(() => {
          console.log('11111111111111111111')
          this.$refs['dataForm'].resetFields()
          this.dataForm.salaryTemplateId = id.salaryTemplateId
        })

      },

      getSalaryTemplates() {
        this.$http({
          url: '/bjba/salary/template/queryAll',
          method: 'get',
          params: {}
        }).then(({data}) => {
          if (data && data.code === 200) {

            this.salaryTemplates = data.data
          } else if(data && data.code === 500) {
            this.$message({
              message: data.message,
              type: 'error',
              duration: 1500
            })
          }
        })
      },
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: '/bjba/salary/setSalary',
              method: 'post',
              params: {userid:this.dataForm.userid,salaryTemplateId:this.dataForm.salaryTemplateId}
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.visible = false
                this.$emit('refreshDataList')
              } else if(data && data.code === 500) {
                this.$message({
                  message: data.message,
                  type: 'error',
                  duration: 1500
                })
              }
            })


          }
        })
      }
    }
  }
</script>
